exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.dk-tab-control[data-v-68e7d5a9] {\n    -webkit-tap-highlight-color: transparent;\n}\n", ""]);
